import React from 'react';

import {ARCHIVED_ANALYSIS_TOOLTIP_TEXT} from 'analysis-tool/AnalysisToolConstants';
import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import getLegacyStepFromAnalysis from 'analysis-tool/data/getStepFromAnalysis';
import {AnalysisRightSidebarItem} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import AddChartViewPopover from 'analysis-tool/ui/charting/AddChartViewPopover';
import {FAILED_STEP_MESSAGE} from 'analysis-tool/ui/main-view/MainViewConstants';
import {AnalysisMainViewItem} from 'analysis-tool/ui/main-view/MainViewTypes';
import isArchived from 'archive/isArchived';
import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';

import DataFrameActionButton from '../DataFrameActionButton';
import {PrimaryActionRenderFn} from '../DataFrameActionToolbar';

function getCannotCreateViewTooltipText(analysis: AnalysisGraphQL, stepId: string): string | undefined {
  if (isArchived(analysis)) {
    return ARCHIVED_ANALYSIS_TOOLTIP_TEXT;
  } else if (getLegacyStepFromAnalysis(analysis, stepId).statusCode === PipelineStepStatusCode.FAILED) {
    return FAILED_STEP_MESSAGE;
  }

  return undefined;
}

/**
 * Create an "Add view" action button function for a data frame that is being viewed in the analysis tool.
 */
export function createRenderAddChartViewButton(
  analysis: AnalysisGraphQL,
  stepId: string,
  dataFrameId: string,
  onOpenStepInitializationView: (newSelectedItem: AnalysisMainViewItem) => void,
  onChangeSelectedRightSidebarItem: (newSelectedRightSidebarItem: AnalysisRightSidebarItem | null) => void
): PrimaryActionRenderFn {
  const disabledTooltip = getCannotCreateViewTooltipText(analysis, stepId);

  return () => (
    <AddChartViewPopover
      analysis={analysis}
      stepId={stepId}
      dataFrameId={dataFrameId}
      onOpenStepInitializationView={onOpenStepInitializationView}
      onChangeSelectedRightSidebarItem={onChangeSelectedRightSidebarItem}
      key="AddChartViewButton"
    >
      {(openMenu) => (
        <DataFrameActionButton
          disabled={disabledTooltip != null}
          icon="chart-plus"
          onClick={disabledTooltip == null ? openMenu : undefined}
          title={disabledTooltip ?? 'Add view'}
        />
      )}
    </AddChartViewPopover>
  );
}
